import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { HeaderContainer } from '../../resources/styling/appStyle';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import Box from '@mui/material/Box';

function Header() {

    const [toggled, setToggled] = React.useState(false);
    const [breakpoint, setBreakPoint] = React.useState(window.matchMedia('(max-width: 1024px)').matches);   

    const contentHeader = (
        <div className='main-header-content'>
            <div>
                {breakpoint && (
                    <button className="sb-button" onClick={() => setToggled(!toggled)}>
                        <MenuRoundedIcon/>
                    </button>
                )}
            </div>

            <div className='mobile-logo'>
            <img alt='' src='https://welbee.international/wp-content/uploads/2021/04/welbee_logo_yellow.png'></img>
            </div>
            <Box
            sx={{
                display: {
                xs: 'block',
                sm: 'block',
                md: 'block',
                xl: 'none',
                lg: 'none',
                },
            }}
            >
            <div className='btn-request-assistance'>
                <MarkunreadIcon sx={{ fontSize: 20 }} />
            </div>
            </Box>
        </div>
    );
    
    return (
        <HeaderContainer>
            <div className='mobile-header'>{contentHeader}</div>  
            <div className='admin-main-header'>
                <Grid container>
                    <Grid item xs={7} lg={7}>
                        <h1 className='header-school-title'>Welcome Super Admin</h1>
                    </Grid>
                    <Grid item xs={5} lg={5}>
                        <Stack direction="row" spacing={1} justifyContent='end'>                            
                            <Avatar alt="Zohaib Rafique" src="" sx={{ width: 40, height: 40 }} variant="rounded" />
                            <Stack direction="column" spacing={0} className='user-data'>
                                <div className='user-name'></div>                            
                                <div className='user-email'></div>
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
            </div>
        </HeaderContainer >
    );
}

export { Header };